import React from "react";

const Apps: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="6"
        height="6"
        rx="1"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
      <rect
        x="14"
        y="4"
        width="6"
        height="6"
        rx="1"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
      <rect
        x="4"
        y="14"
        width="6"
        height="6"
        rx="1"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
      <rect
        x="14"
        y="14"
        width="6"
        height="6"
        rx="1"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
};

export default Apps;
